import { Button } from "@/components/ui/button";
import { BarChart3, MessageSquare, Settings2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ManagementButtons } from "./ManagementButtons";

interface ManagementSectionProps {
  gymId: string;
}

export const ManagementSection = ({ gymId }: ManagementSectionProps) => {
  const navigate = useNavigate();

  return (
    <div className="space-y-4 pt-4 border-t border-border/50">
      <div className="flex items-center gap-2 mb-2">
        <div className="p-1.5 rounded-lg bg-primary/10">
          <Settings2 className="h-4 w-4 text-primary" />
        </div>
        <h4 className="text-sm font-medium text-foreground">Gestión del Gimnasio</h4>
      </div>

      <ManagementButtons gymId={gymId} />

      <Button 
        variant="outline" 
        onClick={() => navigate(`/estadisticas-gimnasio/${gymId}`)}
        className="w-full bg-gradient-to-r from-primary/10 to-primary/5 border-primary/30 hover:border-primary/50 hover:from-primary/15 hover:to-primary/10 transition-all"
      >
        <BarChart3 className="mr-2 h-4 w-4 text-primary" />
        Estadísticas del Gimnasio
      </Button>

      <Button 
        variant="outline" 
        onClick={() => navigate(`/mensajes-socios/${gymId}`)}
        className="w-full bg-gradient-to-r from-primary/10 to-primary/5 border-primary/30 hover:border-primary/50 hover:from-primary/15 hover:to-primary/10 transition-all"
      >
        <MessageSquare className="mr-2 h-4 w-4 text-primary" />
        Mensajes de Socios
      </Button>
    </div>
  );
};
